import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createGroup, getAllGroups, } from 'store/entities/groups/action';
import GroupEmployeesSelection from './GroupEmployeesSelection';
import DynamicHeadTag from 'components/__new/common/DynamicHeadTag';

const CreateNewGroup = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(false);
    const { createGroupLoading: loading, } = useSelector(state => state.entities.groups)
    const [createFormShown, setCreateFormShown] = useState(true);
    const [payload, setPayload] = useState({
        groupName: "",
        withdrawalPercent: "",
        autoWithdrawals: "",
        includeEmployees: false
    });

    const updatePayload = (e) => setPayload({ ...payload, [e.target.name]: e.target.value })
    const returnToGroups = () => history.push('/groups')

    const updateGroupDetails = (e) => {
        e.preventDefault()
        const { autoWithdrawals: payloadWdl, includeEmployees } = payload
        const params = {
            ...payload,
            autoWithdrawals: payloadWdl === 'true' ? true : false,
            colorCode: "#FF3A44"
        }
        dispatch(createGroup(params)).then(() => {
            if (includeEmployees) {
                setCreateFormShown(false)
                setIsLoading(true)
                setTimeout(() => {
                    dispatch(getAllGroups()).then(() => setIsLoading(false))
                }, 2000)
            } else {
                returnToGroups()
            }

        })
    }

    return createFormShown ? (
        <div>
            <DynamicHeadTag headerText="Company | Create Group" headerDescription="" />
            <div onClick={returnToGroups} className="page-title flex items-center cursor-pointer">
                <FontAwesomeIcon icon="angle-left" className='mr-4' />
                New Group
            </div>

            <div className="w-full bg-white mt-10 p-4 lg:p-8 rounded-lg">
                <p className="mb-7 lg:mb-10 text-sm">Create new group policy</p>

                {loading ? <div className="table-info">
                    <FontAwesomeIcon icon="circle-notch" spin />
                    <div className="font-semibold uppercase">
                        Processing
                    </div>
                </div> : <form onSubmit={updateGroupDetails}>
                    <div className="w-full lg:w-2/5 space-y-10">
                        <div className="form-group">
                            <label>
                                Group Name
                                <span className="form-input-required">*</span>
                            </label>
                            <input required onChange={updatePayload} type="text" name="groupName" placeholder='Marketing' className="form-input" />
                        </div>

                        <div className="form-group">
                            <label>
                                Salary Auto-Withdrawal
                                <span className="form-input-required">*</span>
                            </label>
                            <select required name="autoWithdrawals" className="form-input" value={payload.autoWithdrawals}
                                onChange={updatePayload}>
                                <option value="">Select Option</option>
                                <option value="true">Allow Access</option>
                                <option value="false">Require Business's Approval</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label>
                                Group Salary Withdrawal Limit
                                <span className="form-input-required">*</span>
                            </label>
                            <select required name="withdrawalPercent" className="form-input" value={payload.withdrawalPercent}
                                onChange={updatePayload}>
                                <option value="">Select Option</option>
                                <option value="50">50%</option>
                                <option value="75">75%</option>
                            </select>
                        </div>

                        <div className="flex items-center space-x-1">
                            <input onChange={() => setPayload({ ...payload, includeEmployees: !payload.includeEmployees })} defaultChecked={payload.includeEmployees} type="checkbox" className="w-5 h-5 mr-2 form-checkbox float-left" />
                            <p className="mb-0 text-sm">Add Employees to this group</p>
                        </div>

                        <div className="flex items-center space-x-7">
                            <button type="submit" className="btn btn-md btn-ep-primary">
                                Create Group
                            </button>

                            <button onClick={returnToGroups} type="button" className="btn btn-md text-ep-primary border border-ep-primary">
                                Cancel
                            </button>
                        </div>
                    </div>
                </form>}
            </div>
        </div>
    ) : <GroupEmployeesSelection isLoading={isLoading} payload={payload} setCreateFormShown={setCreateFormShown} returnToGroups={returnToGroups} />
}

export default CreateNewGroup